import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const GA_TRACKING_ID = 'UA-132477921-6';
export const GTM_TRACKING_ID = 'GTM-WWJXT78';

export function pageview(url) {
  if (!publicRuntimeConfig.isProduction) {
    console.log('gtag.js#pageview', arguments[0]);

    return;
  }

  window.gtag('config', GA_TRACKING_ID, {
    page_location: url,
    anonymize_ip: true,
  });
}

export function event({ action, category, label, value }) {
  if (!publicRuntimeConfig.isProduction) {
    console.log('gtag.js#event', arguments[0]);

    return;
  }

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
}

export function gtmEvent(event) {
  if (!publicRuntimeConfig.isProduction) {
    console.log('gtag.js#gtmEvent', event);

    return;
  }

  window.gtmDataLayer.push({ event });
}

export function getUtmTags() {
  if (!window.location.search) {
    return null;
  }

  const isUtmParameter = value => value.indexOf('utm_') === 0;

  return window.location.search
    .substring(1)
    .split('&')
    .filter(isUtmParameter)
    .join('&');
}

export function removeUtmFromUrl() {
  const isNotUtmParameter = value => value.indexOf('utm_') !== 0;

  const filteredQuery = window.location.search
    .substring(1)
    .split('&')
    .filter(isNotUtmParameter)
    .join('&');

  window.history.replaceState(
    null,
    null,
    window.location.pathname +
      (filteredQuery ? '?' + filteredQuery : '') +
      window.location.hash
  );
}
